import iamAPI from "../../api/iamAPI";
import { urlContexts } from "../../constants";

export const getUserInfo = async () => {
  const { data } = await iamAPI.get(
    `${process.env['REACT_APP_IAM_API_HOST'] || process.env['REACT_APP_BACKEND_HOST']}/${urlContexts.iam_back}/rest/1.0/auth/getUserInfo`,
    {
      headers: {
        Authorization: `Bearer ${sessionStorage?.getItem('REDIRECT::INFO') || ''}`,
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
      }
    }
  );

  return data;
};